<div class="save-changes-form">
    <div class="subtitle">{{ changes.length }} change{{ changes.length === 1 ? '' : 's' }}</div>

    <ul class="change-summary" *ngIf="summaryLines.length">
        <li *ngFor="let line of summaryLines"><b>{{ line.count }}</b> {{ line.label }}</li>
    </ul>

    <p class="note">Changes take effect at the next overnight run.</p>

    <div class="form-row">
        <label>Reason for this change <span class="optional">(optional)</span></label>
        <input class="k-textbox" [(ngModel)]="reason" name="reason" placeholder="Recorded in the change history" />
    </div>

    <div class="saving-as">Saving as {{ email }}</div>

    <kendo-dialog-actions [layout]="'normal'">
        <button kendoButton (click)="onCancel()">Cancel</button>
        <button kendoButton [primary]="true" (click)="onSave()"><i class="fas fa-save save-icon"></i>Save</button>
    </kendo-dialog-actions>
</div>
